import { css } from '@emotion/core';
import { Paragraph3, Paragraph4 } from '@nexus/lib-react/dist/core/Typography/Paragraph';
import styled from '../../../../../theme/styled';
import { progressiveLoading } from '../../../../../commons/styles/animations';

const loadingLine = (heightPx: number, width: string) => css`
  &:empty {
    margin: 4px;
    height: ${heightPx}px;
    width: ${width};
    ${progressiveLoading()}
  }
`;

const Wrapper = styled.div``;

const Title = styled(Paragraph3)`
  text-transform: capitalize;
`;

const TitleWithMargin = styled(Paragraph3)`
  margin: 8px 0;
`;

const Description = styled(Paragraph4)`
  text-transform: capitalize;
  ${(props: { loadingWidth: string }) => loadingLine(12, props.loadingWidth)}
`;

export default { Wrapper, Title, Description, TitleWithMargin };
